export default "__VITE_ASSET__BqYbZHgL__"